import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import localCommunityGridImage1 from 'assets/img/local-community-occasion-grid-1.jpg'
import localCommunityGridImage2 from 'assets/img/local-community-occasion-grid-2.jpg'
import localCommunityGridImage3 from 'assets/img/local-community-occasion-grid-3.jpg'
import localCommunityGridImage4 from 'assets/img/local-community-occasion-grid-4.jpg'
import communityConcessionsBanner from 'assets/img/community-concessions-banner.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

export default function LocalCommunityConcessionsPage() {
  const { openModal, ...modalState } = useModalState()

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Food Trucks for Local Community Events - Roaming Hunger</title>
        <meta name="description" content="Food trucks are great food and beverage concessions for local community events. We'll help you find the best food trucks in your area."></meta>
        <meta name="og:title" content="Food Trucks for Local Community Events"></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <ImageHero
        imageUrl={communityConcessionsBanner}
        title="Local Community Events"
        onButtonClick={openModal}
        description="Feed hungry crowds at your next block party, street fair, or high school football game with fun and exciting food trucks."
      />
      <NavbarFixed menuItems={navMenu} onButtonClick={openModal} />
      <OccasionPageGrid>
        <OccasionPageGridRow
          heading="Connect to Local Food Trucks"
          content="Connect with a wide range of local concession food trucks with the click of a button."
          image={localCommunityGridImage1}
          reverse
        />
        <OccasionPageGridRow
          heading="Make Food a Reason to Attend"
          content="Get your attendees eager to eat. Delicious, modern and on-trend, food trucks appeal to the senses and drive food and beverage concession sales."
          image={localCommunityGridImage2}
        />
      </OccasionPageGrid>
      <FeaturedClients onButtonClick={openModal} />
      <OccasionPageGrid>
        <OccasionPageGridRow
          heading="Something for Everyone"
          content="Keep all your attendees well fed. With over 23,000 food trucks in the Roaming Hunger network, it's easy to curate different kinds of concession foods that appeal to families, foodies and everyone in between."
          image={localCommunityGridImage3}
          reverse
        />
        <OccasionPageGridRow
          heading="Support Local Business"
          content="Support your community and reinvest back into the local economy. 98% of food trucks are small businesses owned or operated by chef entrepreneurs. Just remember, we've found that less than 10% of people will eat at a truck if outside food is permitted, and some trucks may request a minimum if attendance is below 1000 people."
          image={localCommunityGridImage4}
        />
      </OccasionPageGrid>
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks heading="How Local Event Food Concessions Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Local Event Food Concessions Works" onButtonClick={openModal} />
      <OccasionsSlider className="bg-white py-12" heading="Other catering occasions" onButtonClick={openModal} />
    </Layout>
  )
}

const navMenu = [
  {
    title: 'Community Events',
    url: '/food-truck-catering/local-community-concessions/',
    active: true,
  },
  {
    title: '100% Roaming Hunger Event Guarantee',
    url: '/food-truck-catering/community-concessions-event-guarantee/',
  },
  {
    title: 'Food Trucks For Bars, Breweries, and Wineries',
    url: '/food-truck-catering/food-trucks-for-bars-breweries-wineries/',
  }
]
